import { gql } from "@apollo/client";import { useLazyQuery } from "@apollo/client/react";import * as React from 'react';
import Cookies from 'universal-cookie';

import toast, { Toaster } from 'react-hot-toast';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import '../../../../assets/css/App.css';
import ErrorDialog from '../../../../components/ErrorDialog';
import moment from 'moment';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { useLogout } from "../../../../components/hooks/useLogout";

export default function RefreshToken(props) {
  const cookies = new Cookies();

  const { onClose, open, timerCheck, ...other } = props;

  // tiempo inicial del contador en segundos
  let TIEMPO_CONTADOR = "--";
  // etiqueta inicial del timer
  const TIEMPO_INICIAL = '00:' + TIEMPO_CONTADOR;
  // tiempo en segundos para mostrar cercanía a fin de sesión
  const TIEMPO_ALERTA = 10;

  const Ref = useRef(null);
  const [timer, setTimer] = useState(TIEMPO_INICIAL);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);


  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  useEffect(() => {
    if (open) {
      // var fechaActual = moment();
      // var fechaToken = moment(sessionStorage.getItem("accessTokenValidTo").toString(), "DD/MM/YYYY h:mm:ss a");
      // TIEMPO_CONTADOR = fechaToken.diff(moment(fechaActual, "DD/MM/YYYY h:mm:ss a"), 'seconds');
      TIEMPO_CONTADOR = 59;
      clearTimer(getDeadTime());
    } else {
      if (Ref.current) clearInterval(Ref.current);
    }
  }, [open]);

  const logout = useLogout();

  const handleClose = async () => {
    await logout();
    sessionStorage.clear();
    cookies.remove("accessToken");
    cookies.remove("idUsuario");
    cookies.remove("auditoria_filter_accion");
    cookies.remove("auditoria_filter_fechaDesde");
    cookies.remove("auditoria_filter_fechaHasta");
    window.location.replace('/');
  };

  const tokenValido = () => {
    try {
      var fechaActual = moment.utc();
      var fechaToken = moment.utc(sessionStorage.getItem("accessTokenValidTo").toString());
      return fechaToken.diff(fechaActual, 'seconds') > 0;
    } catch {
      return false;
    }
  };

  const QRefreshToken = gql`
        query QRefreshToken ($idUsuario: Int!) {
            refreshToken
            (
                idUsuario: $idUsuario,
            ) 
            {
                success,
                error,
                valorEsperado {
                    valido,
                    token,
                    tokenValidTo
                } 
            }
        }`;

  const [refreshToken, { data: dataRefreshToken, error: errorRefreshToken }] = useLazyQuery(QRefreshToken, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRefreshToken) return;
    // actualizo el token si obtuve respuesta correcta
    if (dataRefreshToken.refreshToken.success) {
      cookies.set('accessToken', dataRefreshToken.refreshToken.valorEsperado.token);

      sessionStorage.setItem('accessToken', dataRefreshToken.refreshToken.valorEsperado.token);
      sessionStorage.setItem('accessTokenValidTo', dataRefreshToken.refreshToken.valorEsperado.tokenValidTo);

      if (Ref.current) clearInterval(Ref.current);

      onClose();
    } else if (dataRefreshToken.refreshToken.error === 'ERRORDB' || parseInt(dataRefreshToken.refreshToken.error, 10) > 0) {
      setMensajeError(dataRefreshToken.refreshToken.error);
    } else {
      setMensajeError(dataRefreshToken.refreshToken.error);
    }
  }, [dataRefreshToken]);  

  useEffect(() => {
    if (!errorRefreshToken) return;
    setMensajeError("ERRORDB");
  }, [errorRefreshToken]);  

  const handleAccept = () => {
    if (tokenValido()) {
      let result = refreshToken({ variables: { idUsuario: idUsuario } });
    } else {
      toast.error("Su sesión en el sistema ha Finalizado.");
      setTimeout("handleClose()", 1000);
    }
  };

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor(total / 1000 % 60);
    const minutes = Math.floor(total / 1000 / 60 % 60);
    const hours = Math.floor(total / 1000 * 60 * 60 % 24);
    return {
      total, hours, minutes, seconds
    };
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : '0' + minutes) + ':' + (
        seconds > 9 ? seconds : '0' + seconds)
      );
    } else {
      // antes de cerrar el dlg y salir de sesión verifico si no fue refrescado el token
      // en otro tab
      if (!tokenValido()) {
        handleClose();
      } else {
        if (Ref.current) clearInterval(Ref.current);
        onClose();
      }
    }
  };

  const clearTimer = (e) => {

    setTimer(TIEMPO_INICIAL);

    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + TIEMPO_CONTADOR);
    return deadline;
  };

  const timerStyled = () => {
    let seconds = parseInt(timer.split(':')[1], 10);
    if (seconds <= TIEMPO_ALERTA) {
      return <div>Tiempo de Sesión&nbsp;<span class='red'>{timer}</span></div>;
    } else {
      return <div>Tiempo de Sesión&nbsp;{timer}</div>;
    }
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>
            <CustomDialog
        open={open}
        {...other}
        title={timerStyled()}
        onAccept={handleAccept}
        acceptText='Continuar'
        onCancel={handleClose}
        cancelText='Salir del sistema'
        sx={{ zIndex: '10000000 !important' }}>
        
                <div style={{ width: '100%' }}>
                    Su <strong>sesión</strong> en el sistema <strong>está por finalizar</strong>, si desea continuar operando presione <strong>Continuar</strong>, de lo contrario
                    si termina el tiempo del contador será redirigido a la pantalla de ingreso.
                </div>
            </CustomDialog>

            
            <ErrorDialog
        id="dlg-error-refresh"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

}